import React from "react";
import LayoutHOC from "../LayoutHOC";
import Select from "../UniversalComponents/SelectComponent";
import Input from "../UniversalComponents/InputComponent";
import Button from "../UniversalComponents/DefaultButton";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import { ReactComponent as DownAngleBracket } from "../../assets/images/downAngleBracket.svg";
import VendorHeaderHoc from "./VendorHeaderHoc";
import TableComponent from "../UniversalComponents/TableComponent";

const Bills = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedPaymentValue, setSelectedPaymentValue] = useState("");
  const [selectedTermValue, setSelectedTermValue] = useState("");
  const [inputTextValue, setInputTextValue] = useState("");
  const [inputTagValue, setInputTagValue] = useState("");
  const [billDate, setBillDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [isOpen, setIsOpen] = useState("true");
  const [isOpenItem, setIsItemOpen] = useState();
  const [isCategoryRotated, setIsCategoryRotated] = useState();
  const [isRotated, setIsRotated] = useState(true);

  const optionData = ["Privacy", "Print ", "Make Recurring"];
  const vendorOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const mailingOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const termsOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const tagOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };
  const handleSelectPaymentChange = (e) => {
    setSelectedPaymentValue(e.target.value);
  };
  const handleSelectTermChange = (e) => {
    setSelectedTermValue(e.target.value);
  };

  const handleInputTextChange = (e) => {
    setInputTextValue(e.target.value);
  };
  const handleInputTagChange = (e) => {
    setInputTagValue(e.target.value);
  };

  const handleButtonClick = () => {
    console.log("Button clicked!");
  };
  const handleSaveButtonClick = () => {
    console.log("Save Button clicked!");
  };
  const handleCancelButtonClick = () => {
    console.log("Cancel Button clicked!");
  };

  const handleCategoryClick = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
    setIsCategoryRotated(!isCategoryRotated);
  };

  const handleItemClick = (e) => {
    e.preventDefault();
    setIsItemOpen(!isOpenItem);
    setIsRotated(!isRotated);
  };
  const onChange = (dates) => {
    if (Array.isArray(dates)) {
      const [start] = dates;
      setBillDate(start);
    } else {
      setBillDate(dates);
    }
  };
  const onDueChange = (dates) => {
    if (Array.isArray(dates)) {
      const [start] = dates;
      setDueDate(start);
    } else {
      setDueDate(dates);
    }
  };

  const placeholderDate = "DD-MM-YYYY";
  const displayFormat = "dd-MM-yyyy";

  return (
    <form className="mx-10 ">
      <div className="  flex gap-3">
        <div className="bg-white border border-[#D6D3D3] px-4 w-[90%] rounded">
          <div className="space-x-2 flex pt-4 justify-between w-full">
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Vendor</label>
              <div>
                <Select
                  placeholder={"Choose a Vendor"}
                  options={vendorOptions}
                  value={selectedValue}
                  onChange={handleSelectChange}
                  style={{ width: "100%", height: "35px", padding: "5px", color: "#AFAFAF", fontSize: "12px" }}
                />
              </div>
            </div>
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Mailing Address</label>
              <div>
                <Select
                  placeholder="Enter mail Address"
                  options={mailingOptions}
                  value={selectedPaymentValue}
                  onChange={handleSelectPaymentChange}
                  style={{ width: "100%", height: "35px", padding: "5px", color: "#AFAFAF", fontSize: "12px" }}
                />
              </div>
            </div>
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Terms</label>
              <div>
                <Select
                  placeholder="Choose a Terms"
                  options={termsOptions}
                  value={selectedTermValue}
                  onChange={handleSelectTermChange}
                  style={{ width: "100%", height: "35px", padding: "5px", color: "#AFAFAF", fontSize: "12px" }}
                />
              </div>
            </div>
          </div>
          <div className="flex space-x-2 pt-4 pb-4 w-full">
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Bill Date</label>
              <div className="w-full">
                <div className="flex items-center bg-white datePicker_container rounded">
                  <DatePicker
                    selected={billDate}
                    onChange={onChange}
                    billDate={billDate}
                    placeholderText={placeholderDate}
                    datedivat={displayFormat}
                    className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
                  ></DatePicker>

                  <div>
                    <CalendarWithTimeIcon></CalendarWithTimeIcon>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Due Date</label>
              <div className="flex items-center bg-white  datePicker_container rounded">
                <DatePicker
                  selected={dueDate}
                  onChange={onDueChange}
                  dueDate={dueDate}
                  placeholderText={placeholderDate}
                  dateFormat={displayFormat}
                  className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
                ></DatePicker>

                <div>
                  <CalendarWithTimeIcon></CalendarWithTimeIcon>
                </div>
              </div>
            </div>
            <div className="w-full">
              <label className=" text-14 text-434852 font-400 pb-1 ">Bill Number</label>
              <Input
                placeholder="Enter Bill Number"
                name="myInput"
                value={inputTextValue}
                onChange={handleInputTextChange}
                style={{ width: "100%", height: "35px", padding: "5px" }}
              />
            </div>
          </div>
          <div className="flex space-x-2  pb-4 w-full">
            <div className="w-[33%]">
              <label className=" text-14 text-434852 font-400 pb-1 ">Tags</label>
              <Select
                placeholder="choose an option"
                options={tagOptions}
                value={inputTagValue}
                onChange={handleInputTagChange}
                style={{ width: "100%", color: "#AFAFAF", fontSize: "12px", height: "35px", padding: "5px" }}
              />
              <label className=" text-12 text-[#009CBF] font-400 pb-1 pe-1">Manage Tags</label>
            </div>
          </div>
        </div>
        <div className=" border border-[#D6D3D3]   bg-white flex justify-center items-center h-[200px] rounded">
          <div className="flex flex-col items-center border bg-[#0093C1] rounded-md text-white p-1 px-8 mx-5">
            <span className="text-16 font-400 whitespace-nowrap">Available Balance</span>
            <div className="text-30 font-600" onClick={handleButtonClick}>
              $ 0.00
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-start space-x-2 py-3">
        <div className="text-18 font-600 text-1D4469">Category Details</div>
        <div>
          <button onClick={handleCategoryClick}>
            <DownAngleBracket
              className={`h-[10px] text-1D4469 items-center ${isCategoryRotated ? "rotate-180" : ""}`}
            />
          </button>
        </div>
      </div>
      {isOpen && <TableComponent name="categoryDetails" />}
      <div className="flex items-center justify-start space-x-2 py-3">
        <div className="text-18 font-600 text-1D4469">Item Details</div>
        <div>
          <button onClick={handleItemClick}>
            <DownAngleBracket className={`h-[10px] text-1D4469 items-center  ${isRotated ? "rotate-180" : ""}`} />
          </button>
        </div>
      </div>

      <div className={isOpenItem ? "mb-4" : ""}>{isOpenItem && <TableComponent name="itemDetails" />}</div>

      <div className="border bg-white p-4 border-[#D6D3D3]">
        <div className=" flex gap-4 w-[60%]">
          <div className="w-full">
            <label className="text-14 text-434852 font-400 pb-1 ">Memo</label>
            <div>
              <textarea className="rounded-md border-[#DFE2E5]  h-[120px] w-[100%] "></textarea>
            </div>
          </div>
          <div className="w-full">
            <label className="flex justify-between ">
              <label className="text-14 text-434852 font-400 pb-1 ">
                <span className="font-600 ">Attachments(0)</span> Maximum Size 20 MB
              </label>
            </label>
            <div className="flex items-center justify-center rounded-md border-[#DFE2E5] border h-[120px] w-[100%]">
              <div className="flex flex-col items-center">
                <label className="text-[#AFAFAF] text-12 font-400 text-center">
                  Drop files here or click to select from the device
                </label>
                <div className="text-12">Upload from this device </div>
              </div>
            </div>
            <label className=" text-12 text-[#009CBF] font-400 pb-1 pe-1">Show existing</label>
          </div>
        </div>
      </div>

      <div className="flex justify-between py-3 items-center ">
        <div className="">
          <ul className="flex space-x-3  text-[#009CBF] text-12 font-400">
            {optionData.map((option) => (
              <li key={option}>{option}</li>
            ))}
          </ul>
        </div>

        <div className="flex  space-x-2  ">
          <div className="w-[284px] bg-[#D4EAEE] border-[#BEDADF] flex justify-between text-16 text-[#535252] items-center rounded-5px px-2">
            <span className="font-400">Total</span>
            <span className="font-600 ">$ 0.00</span>
          </div>

          <Button type="primary" onClick={handleCancelButtonClick} style={{ color: "#535252", height: "35px" }}>
            CANCEL
          </Button>
          {/* <Button type="primary" style={{ color: "#535252" }}>
            SAVE
          </Button> */}
          <Button type="secondary" onClick={handleSaveButtonClick} style={{ height: "35px" }}>
            SAVE
          </Button>
        </div>
      </div>
    </form>
  );
};

export default LayoutHOC(VendorHeaderHoc(Bills));
